import { useMemo } from 'react';
import { errorDetails, ErrorType } from '../types/AutomationValidation';

export const useGetFieldErrorText = (errors?: ErrorType[]): string => {
  const errorText = useMemo(() => {
    return errors?.map((errorName) => errorDetails[errorName].errorMessage).join('. ');
  }, [errors]);

  return errorText || '';
};
